export default {
    key: 'first',
    type: 'P2P',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    origins: [],
    destinations: [{
        ref: 'urn:uic:stn:8507354',
        name: 'First (Grindelwald)',
    }, {
        ref: 'urn:uic:stn:8507351',
        name: 'Schreckfeld',
    }, {
        ref: 'urn:uic:stn:8507352',
        name: 'Bort',
    }],
    returnOrigins: [],
    returnDestinations: [],
    isRoundtrip: 'optional',
    canSwitchDirection: true,
    canChooseReturnDestination: false,
    isUsingReductionCards: true,
    isUsingKeyCards: false,
    isUsingPromos: true,
    isPromotionRequired: false,
    hasEPR: false,
    routeVariants: [],
    routeVariantUp: 'default-first',
    routeVariantDown: 'default-first',
    upsells: ['upsell-first-flyer', 'upsell-first-glider'],
    isUpsellDatesRestricted: false,
    isUsingSeasonDates: false,
    departureTimeIteration: 30,
    departureTimeDefaultMin: 420,
    stayDurationIteration: 30,
    stayDurationPopular: 150,
    stayDurationMin: 30,
    salesTimeLimit: 1065, // 17:45
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: 10,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: 'urn:listing:trips:first',
    isLocalListing: true,
    steps: [
        {
            routeName: 'offerFlow-first-steps-step-1-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-first-steps-step-2-trip-selection',
            name: 'offerFlow.pages.stepTripSelection.name.common',
        },
        {
            routeName: 'offerFlow-first-steps-step-4-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
            skipIfUpsell: true,
        },
    ],

} satisfies ProductConfigP2P;
